module.exports = __webpack_public_path__ + "img/img-contact.9b8181b4.png";